import styles from "./styles.module.scss";

interface IOrgAvatarProps {
  code: string;
  logoUrl?: string;
}

/** The organization's logo, or the first letter of its code when it has none. */
const OrgAvatar = ({ code, logoUrl }: IOrgAvatarProps) => (
  <span className={styles.avatar}>
    {logoUrl ? (
      <img src={logoUrl} alt={code} className={styles.logo} />
    ) : (
      code.charAt(0).toUpperCase()
    )}
  </span>
);

export default OrgAvatar;
